import {
  // Filesystem
  ListDirectoryToolUI,
  ReadFileToolUI,
  WriteFileToolUI,
  EditFileToolUI,
  DeleteFileToolUI,
  // Knowledge & context
  LoadSkillToolUI,
  GetContextSourceToolUI,
  // Data & query
  QueryToolUI,
  ExportDataToolUI,
  GetTableMetadataToolUI,
  // Knowledge / guidance
  ListGuidancesToolUI,
  GetGuidanceToolUI,
  UpdateDraftGuidanceToolUI,
  CreateDraftGuidanceToolUI,
  PublishGuidanceToolUI,
  ListGuidanceTemplatesToolUI,
  // Skills (intent-linked articles)
  ListSkillsToolUI,
  GetSkillToolUI,
  CreateDraftSkillToolUI,
  UpdateDraftSkillToolUI,
  PublishSkillToolUI,
  ListIntentsToolUI,
  // AI Agent settings
  GetAgentConfigurationToolUI,
  UpdateToneOfVoiceToolUI,
  UpdateExcludedHandoverTopicsToolUI,
  // Merchant website
  GetMerchantSitemapToolUI,
  ReadMerchantWebsiteToolUI,
  GetProductCatalogToolUI,
  // Opportunities
  ListOpportunitiesToolUI,
  GetOpportunityToolUI,
  ProcessOpportunityToolUI,
  // AI Agent actions
  ListSupportActionsToolUI,
  GetSupportActionToolUI,
  CreateSupportActionToolUI,
  UpdateSupportActionToolUI,
  EnableSupportActionToolUI,
  DisableSupportActionToolUI,
  ConvertToAdvancedViewToolUI,
  // AI Agent action templates
  ListActionTemplatesToolUI,
  GetActionTemplateToolUI,
  CreateActionFromTemplateToolUI,
  // Navigation
  NavigateUserToolUI,
  // AI Agent preview
  PreviewAiAgentToolUI,
  PreviewToneOfVoiceToolUI,
  // Cortex: Data aliases
  ExecuteQueryToolUI,
  // Cortex: Conversation
  GenerateFinalAnswerToolUI,
  AskClarifyingQuestionsToolUI,
  // Cortex: Web
  WebSearchToolUI,
  WebFetchToolUI,
  // Cortex: Utilities
  GenerateSignedGcsLinkToolUI,
  ProvideSqlToolUI,
  ProvideFeedbackToolUI,
  SetThinkingModeToolUI,
  // Cortex: Slack
  SendSlackMessageToolUI,
  ReadCurrentThreadToolUI,
  ReadSlackChannelToolUI,
  SearchSlackUserToolUI,
  SearchSlackChannelToolUI,
  // Plan
  WritePlanToolUI,
  // Tasks
  ExecuteTaskToolUI,
} from '@/client/components/assistant-ui/tool-uis';
import { CelebrationToolUI } from '@/client/components/chat/CelebrationCard';

export function ToolUiRegistrations() {
  return (
    <>
      {/* Filesystem */}
      <ListDirectoryToolUI />
      <ReadFileToolUI />
      <WriteFileToolUI />
      <EditFileToolUI />
      <DeleteFileToolUI />
      {/* Knowledge & context */}
      <LoadSkillToolUI />
      <GetContextSourceToolUI />
      {/* Data & query */}
      <QueryToolUI />
      <ExportDataToolUI />
      <GetTableMetadataToolUI />
      {/* Knowledge / guidance */}
      <ListGuidancesToolUI />
      <GetGuidanceToolUI />
      <UpdateDraftGuidanceToolUI />
      <CreateDraftGuidanceToolUI />
      <PublishGuidanceToolUI />
      <ListGuidanceTemplatesToolUI />
      {/* Skills (intent-linked articles) */}
      <ListSkillsToolUI />
      <GetSkillToolUI />
      <CreateDraftSkillToolUI />
      <UpdateDraftSkillToolUI />
      <PublishSkillToolUI />
      <ListIntentsToolUI />
      {/* AI Agent settings */}
      <GetAgentConfigurationToolUI />
      <UpdateToneOfVoiceToolUI />
      <UpdateExcludedHandoverTopicsToolUI />
      {/* Merchant website */}
      <GetMerchantSitemapToolUI />
      <ReadMerchantWebsiteToolUI />
      <GetProductCatalogToolUI />
      {/* Opportunities */}
      <ListOpportunitiesToolUI />
      <GetOpportunityToolUI />
      <ProcessOpportunityToolUI />
      {/* AI Agent actions */}
      <ListSupportActionsToolUI />
      <GetSupportActionToolUI />
      <CreateSupportActionToolUI />
      <UpdateSupportActionToolUI />
      <EnableSupportActionToolUI />
      <DisableSupportActionToolUI />
      <ConvertToAdvancedViewToolUI />
      {/* AI Agent action templates */}
      <ListActionTemplatesToolUI />
      <GetActionTemplateToolUI />
      <CreateActionFromTemplateToolUI />
      {/* Navigation */}
      <NavigateUserToolUI />
      {/* AI Agent preview */}
      <PreviewAiAgentToolUI />
      <PreviewToneOfVoiceToolUI />
      {/* Cortex: Data (aliases) */}
      <ExecuteQueryToolUI />
      {/* Cortex: Conversation */}
      <GenerateFinalAnswerToolUI />
      <AskClarifyingQuestionsToolUI />
      {/* Cortex: Web */}
      <WebSearchToolUI />
      <WebFetchToolUI />
      {/* Cortex: Utilities */}
      <GenerateSignedGcsLinkToolUI />
      <ProvideSqlToolUI />
      <ProvideFeedbackToolUI />
      <SetThinkingModeToolUI />
      {/* Cortex: Slack */}
      <SendSlackMessageToolUI />
      <ReadCurrentThreadToolUI />
      <ReadSlackChannelToolUI />
      <SearchSlackUserToolUI />
      <SearchSlackChannelToolUI />
      {/* Plan */}
      <WritePlanToolUI />
      {/* Tasks */}
      <ExecuteTaskToolUI />
      {/* Onboarding */}
      <CelebrationToolUI />
    </>
  );
}
